
import axios from "axios";
import api from "./api";

// Crear una instancia de axios
const axiosInstance = axios.create({
  baseURL: api.baseURL,
});

// Configurar el interceptor de solicitudes
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      console.log('Adding Authorization header:', `Bearer ${token}`); // Agregar este log
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.log('No token found in localStorage');
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Configurar el interceptor de respuestas
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // El token ha expirado o no es válido
      localStorage.removeItem("token");
      // Redirigir al usuario a la página de inicio de sesión
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
